import React from 'react';
import { Alert, Stack, TextField, Typography } from '@mui/material';

export default function MobileNotificationContentStep({
  value,
  onChange,
  readOnly = false,
  fieldErrors = {},
}) {
  const update = (patch) => {
    onChange({
      ...value,
      ...patch,
    });
  };

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Notification Title"
        value={value?.title || ''}
        onChange={(event) => update({ title: event.target.value })}
        disabled={readOnly}
        error={Boolean(fieldErrors?.title)}
        helperText={fieldErrors?.title || 'Shown in the mobile inbox and push banner.'}
      />

      <TextField
        fullWidth
        multiline
        minRows={5}
        label="Message"
        value={value?.message || ''}
        onChange={(event) => update({ message: event.target.value })}
        disabled={readOnly}
        error={Boolean(fieldErrors?.message)}
        helperText={fieldErrors?.message || 'Keep it concise. This is the push body and inbox message.'}
      />

      <Stack spacing={0.75}>
        <Typography variant="subtitle2">Optional Metadata (JSON)</Typography>
        <TextField
          fullWidth
          multiline
          minRows={4}
          value={value?.data_json || ''}
          onChange={(event) => update({ data_json: event.target.value })}
          disabled={readOnly}
          error={Boolean(fieldErrors?.data || fieldErrors?.data_json)}
          helperText={fieldErrors?.data || fieldErrors?.data_json || 'Optional structured metadata stored on the notification record.'}
        />
      </Stack>

      <Alert severity="info">
        Mobile-only campaigns stay out of the web notification center. Recipients receive a mobile inbox item, with push sent only when an Expo token exists.
      </Alert>
    </Stack>
  );
}
